// removed by extract-text-webpack-plugin
module.exports = {"capture":"main_nav-3TX","text":"main_nav-n8v"};


//////////////////
// WEBPACK FOOTER
// ../src/components/CTA/CaptureCTA/capture_cta.module.scss
// module id = 347
// module chunks = 0